
import { defineComponent, PropType } from 'vue';
import { LinkViewModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'LinkButton',
    props: {
        link: {
            required: true,
            type: Object as PropType<LinkViewModel>,
            default: () => {},
        },
        coverMode: {
            required: false,
            type: Boolean,
            default: true,
        },
        scrim: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
});
